import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { AppointmentConsumption } from '../appointments/appointment-consumption'

export class AppointmentConsumptionRepository extends BaseRepository<AppointmentConsumption> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/appointment-consumption', token, cache)
    }

    // estorna/reativa a cobrança do insumo na comissão do atendente. não mexe no estoque — o insumo
    // continua consumido (ver AppointmentConsumptionService#comissionStatus no scheduler-api).
    async comissionsChangeStatus(appointmentConsumptionId: string, active: boolean) {
        const { json, statusCode, message } = await this.request.post(
            this.config.schedulerApi + '/appointment-consumption/comissions/status?token=' + this.resolvedToken,
            { id: appointmentConsumptionId, active },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
